export function formatDateConverter(dateWrong: string) {
  if (dateWrong) {
    const date = new Date(dateWrong);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  return null;
}

export function maskLastFourCharacters(value: string | null | undefined): string {
  if (!value) return '';
  if (value.length <= 4) return '****';
  return `${value.slice(0, -4)}****`;
}
